import { ProgramNames } from '../../../models'
import { PROGRAM_TAXONOMY, ProgramCustomerPropertyId } from '../../common/constants/customerProgram'
import { TREATMENT_OPTIONS } from '../../common/constants/treatmentOptions'
import { ProgramDisplayLabels } from '../messages'
import { ProgramConfig } from '../types'

export const ICAS_THERAPY_PROGRAM = {
  programName: ProgramNames.ICASTherapy,
  blendedCareProgramId: null,
  customerPropertyId: ProgramCustomerPropertyId.icas,

  displayLabels: {
    default: ProgramDisplayLabels.therapy,
  },

  associatedProviderTypes: [],
  associatedProviderModalities: [],

  canRescheduleAppointment: false,
  selfPayEligible: false,

  treatmentOptionProperties: {
    associatedTriageTreatmentOptions: [TREATMENT_OPTIONS.INDIVIDUAL_THERAPY],
    programTaxonomyTreatmentOptions: [
      {
        clientele: PROGRAM_TAXONOMY.clientele.individual,
        treatment: PROGRAM_TAXONOMY.treatment.therapy,
        partner: PROGRAM_TAXONOMY.partner.icas,
        offering: PROGRAM_TAXONOMY.offering.default,
      },
    ],
    isFullTreatmentOption: false,
  },

  consents: [],
} satisfies ProgramConfig
